import { onError } from "@apollo/client/link/error";
import { some } from "lodash";
import { handleForceLogout } from "@/features/workspace/hooks/useLogout";

const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      // Handle account limit exceeded error
      const accountLimitError = graphQLErrors.find(
        (err) => err.message === "Account limit exceeded"
      );
      if (accountLimitError) {
        window?.Intercom?.("trackEvent", "account-limit-triggered", {
          account: accountLimitError.extensions?.account,
        });
      }

      // Handle unauthenticated error
      if (
        some(
          graphQLErrors,
          (error) => error.extensions?.code === "UNAUTHENTICATED"
        )
      ) {
        handleForceLogout();
      }
    }

    // Handle network error
    if (
      networkError &&
      "statusCode" in networkError &&
      networkError.statusCode === 401
    ) {
      handleForceLogout();
    }
  }
);

export default errorLink;
